"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_link_response_resolver_1 = require("apollo-link-response-resolver");
var date_fns_1 = require("date-fns");
var parseISOorNull = function (value) {
    return typeof value === 'string' ? date_fns_1.parseISO(value) : null;
};
/**
 * Datetime is trasmitted over network as string (ISO format).
 * This link will automatically parse that string and convert to Date object.
 * Manual map of types and fields is necessary to be supplied.
 * If you have some fields aliased, these has to be used here as well.
 *
 * Note that passing Date to mutation, the Apollo will provide auto conversion
 * back to ISO, there is no need to map those.
 *
 * @example
 * createDateParserLink({
 *   CompanyBranch: ['willOpenAt', 'willCloseAt']
 * })
 *
 * @param resolvers
 */
exports.createDateParserLink = function (resolvers) {
    return apollo_link_response_resolver_1.withResponseResolver(Object.keys(resolvers).reduce(function (types, typeName) {
        types[typeName] = resolvers[typeName].reduce(function (fields, fieldName) {
            fields[fieldName] = parseISOorNull;
            return fields;
        }, {});
        return types;
    }, {}));
};
//# sourceMappingURL=createDateParserLink.js.map